import React from 'react'

import CollapsibleContent from '@/components/misc/CollapsibleContent'
import SanitizedHtml from '@/components/misc/SanitizedHtml'
import { useIsPdf } from '@/hooks/useIsPdf'

interface Props {
  example: string
}

const ServiceFeeExample: React.FC<Props> = ({ example }) => {
  const isPdf = useIsPdf()

  return isPdf ? (
    <SanitizedHtml html={example} />
  ) : (
    <CollapsibleContent
      content={example}
      collapseThreshold={130}
      allowHtml
      className="leading-normal [&_p:first-of-type]:mt-0!"
    />
  )
}

export default ServiceFeeExample
